import { useEffect, useState } from "react";
import afespCardFallback from "../assets/images/fallback/afesp-card.png";

export const AFESP_IMAGE_FALLBACK = afespCardFallback;

const FALLBACK_FLAG = "afespFallback";

export function withImageFallback(src?: string | null) {
  return src && String(src).trim() ? src : AFESP_IMAGE_FALLBACK;
}

export function useImageSrc(src?: string | null) {
  const [current, setCurrent] = useState(() => withImageFallback(src));

  useEffect(() => {
    const next = withImageFallback(src);

    if (next === AFESP_IMAGE_FALLBACK) {
      setCurrent(AFESP_IMAGE_FALLBACK);
      return;
    }

    const image = new Image();
    image.onload = () => setCurrent(next);
    image.onerror = () => setCurrent(AFESP_IMAGE_FALLBACK);
    image.src = next;

    return () => {
      image.onload = null;
      image.onerror = null;
    };
  }, [src]);

  return current;
}

export function installImageFallback() {
  const onError = (event: Event) => {
    const target = event.target;
    if (!(target instanceof HTMLImageElement)) {
      return;
    }
    if (target.dataset[FALLBACK_FLAG] === "1") {
      return;
    }
    target.dataset[FALLBACK_FLAG] = "1";
    target.src = AFESP_IMAGE_FALLBACK;
  };

  document.addEventListener("error", onError, true);
  return () => document.removeEventListener("error", onError, true);
}
